import FastAPIInstance from '../../../services/risksystem3-public-api';

/** Resource assignment returned by `GET /user-resources/{user_id}`. */
export type UserResource = {
  id: string;
  name: string;
};

export const NAV_RECONCILIATION_RESOURCE_NAME = 'NAV_RECONCILIATION';

export const hasUserResource = (
  resources: UserResource[] | undefined,
  resourceName: string,
): boolean =>
  !!resources?.some((resource) => resource.name === resourceName);

/**
 * List resources assigned to a user.
 * GET /v1/user-resources/{user_id} (auth_router, same base as /v1/token)
 */
export const getUserResources = async (
  userId: string,
): Promise<UserResource[]> => {
  const { data } = await FastAPIInstance.get<UserResource[]>(
    `/v1/user-resources/${userId}`,
  );
  return data;
};
